import { render } from "./ImageBox.vue?vue&type=template&id=bd54dcf0&scoped=true"
const script = {}

import "./ImageBox.vue?vue&type=style&index=0&id=bd54dcf0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd54dcf0"]])

export default __exports__